// extracted by mini-css-extract-plugin
export default {"amountSetter":"style--amountSetter--13e98d","amount":"style--amount--161564","button":"style--button--bcf183","active":"style--active--40ac7c","passive":"style--passive--d2b0dc"};